import { render, staticRenderFns } from "./CustomBDatePicker.vue?vue&type=template&id=5b65f4a0&"
import script from "./CustomBDatePicker.vue?vue&type=script&lang=js&"
export * from "./CustomBDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports